import React from "react";
import WellnessVaccinationIcon from "../../../components/Icons/WellnessVaccinationIcon";
import WellnessExamsIcon from "../../../components/Icons/WellnessExamsIcon";
import WellnessDiagnosticsIcon from "../../../components/Icons/WellnessDiagnosticsIcon";
import WellnessBloodworkIcon from "../../../components/Icons/WellnessBloodworkIcon";
import WellnessSurgeryIcon from "../../../components/Icons/WellnessSurgeryIcon";
import { Divider } from "@mui/material";
import {
  CategoryItem,
  FlattenedPlanData,
} from "../../../hooks/useWellnessPlans";
import WellnessDiscountIcon from "../../../components/Icons/WellnessDiscountIcon";

interface IWellnesPlanServices {
  planType: string;
  planData: FlattenedPlanData;
  fromAllPlans?: boolean;
}

const WellnesPlanServices = ({
  planType,
  planData,
  fromAllPlans,
}: IWellnesPlanServices) => {
  const reorderServices = (services: Record<string, CategoryItem[]>) => {
    if (!services) return {};

    const entries = Object.entries(services);

    const sorted = entries.sort(([a], [b]) => {
      if (a.toLowerCase() === "discounts") return 1;
      if (b.toLowerCase() === "discounts") return -1;

      return 0;
    });

    return Object.fromEntries(sorted);
  };

  const services = reorderServices(planData.services ?? {});

  const getStyling = () => {
    if (fromAllPlans) return "";
    if (planType === "premiumPlan") {
      return "p-5 border border-violet-6";
    } else {
      return "p-5 border border-taupe-2";
    }
  };

  const getServicesIcon = (servicesName: string) => {
    switch (servicesName.toLowerCase()) {
    case "vaccines":
      return <WellnessVaccinationIcon />;
    case "diagnostics":
      return <WellnessDiagnosticsIcon />;
    case "bloodwork":
      return <WellnessBloodworkIcon />;
    case "surgery":
    case "surgery procedure":
      return <WellnessSurgeryIcon />;
    case "discounts":
      return <WellnessDiscountIcon />;
    default:
      return <WellnessExamsIcon />;
    }
  };

  return (
    <div className={`rounded-b-lg ${getStyling()}`}>
      {planData.description && (
        <div className="text-sm font-semibold">Plan Benefits</div>
      )}

      {services && Object.keys(services).length > 0 && (
        <div className="my-3 flex flex-col gap-3">
          {Object.entries(services).map(([serviceName, items], index, array) => (
            <React.Fragment key={serviceName}>
              <div className="text-sm">
                <div className="flex gap-1">
                  {getServicesIcon(serviceName)}
                  <div className="font-semibold mb-0.5">{serviceName}</div>
                </div>
                <ul className="!list-disc">
                  {items.map((item, itemIndex) => (
                    <li key={itemIndex}>
                      {serviceName.toLowerCase() === "discounts" ? (
                        <span className="font-semibold me-1">
                          {item.discount}% Off
                        </span>
                      ) : (
                        item.quantity !== -1 && (
                          <span className=" me-1">{item.quantity}</span>
                        )
                      )}
                      <span className="">{item.name}</span>
                    </li>
                  ))}
                </ul>
              </div>
              {index < array.length - 1 && <Divider className="w-full !m-0" />}
            </React.Fragment>
          ))}
          {!fromAllPlans && (
            <p className="text-sm">
              *Monthly payment amount and terms determined by ScratchPay based on credit approval.
            </p>
          )}
        </div>
      )}
    </div>
  );
};

export default WellnesPlanServices;

